export default "__VITE_ASSET__C8C5HBl5__"